import { Boundary, BreadcrumbsProps, Classes } from "@blueprintjs/core";
import { Breadcrumbs2 } from "@blueprintjs/popover2";
import React from "react";
import styled from "styled-components";

interface IAppBreadcrumbProps extends Pick<BreadcrumbsProps, "items"> {}

const StyledBreadCrumb = styled(Breadcrumbs2)`
  background-color: ${(props) =>
    props.theme.breadCrumbsColor || "none"} !important;
  padding-left: 1rem;

  & .${Classes.BREADCRUMB} {
    color: ${(props) => props.theme.breadCrumbsTextColor || ""} !important;
    &:hover {
      color: ${(props) => props.theme.tabTextHover} !important;
    }
  }
`;

export const AppBreadcrumb: React.FunctionComponent<IAppBreadcrumbProps> = ({
  items,
}) => {
  React.useEffect(() => {
    if (items) {
      document.title =
        items
          .filter((i) => !!i.text && typeof i.text === "string")
          .map((i) => i.text)
          .join(" > ") + " - My VIA Pro ";
    } else {
      document.title = "My VIA Pro";
    }
  }, [items]);
  return <StyledBreadCrumb items={items} collapseFrom={Boundary.START} />;
};
